import { useMemo } from "react"
import { useAccountConfiguration } from "queries/users"

const useOptInContentSids = (): Set<string> => {
  const { accountConfiguration } = useAccountConfiguration()
  const templates = accountConfiguration?.whatsappTemplates

  return useMemo(
    () => new Set(
      (templates ?? [])
        .filter((t) => t.messageType === "opt_in")
        .map((t) => t.contentSid),
    ),
    [templates],
  )
}

export default useOptInContentSids
